module.exports = __webpack_public_path__ + "static/media/bytt-nn-7.97faffb0.mp3";